import React from "react";
import { DateFormat } from "../../helpers/utils";
import TableBase from "./Base";

const SpinTheWheelOverviewTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Date",
			dataIndex: "date",
			width: 200,
			ellipsis: true,
			render(value) {
				return DateFormat(value);
			},
		},
		{
			title: "Total Spins",
			dataIndex: "total_spins",
			width: 200,
			ellipsis: true,
		},
		{
			title: "Winners",
			dataIndex: "winners",
			width: 200,
			ellipsis: true,
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 50,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default SpinTheWheelOverviewTable;
